import { useState } from 'react';
import { PROGRESS } from '../../../utils/Constants';
import { fetchProgressData } from '../../../utils/fetchSheetData';

let progress: Progress = {
  startDate: '10/2024',
  endDate: '12/2027',
  ending: 0,
  planing: 0,
  phase: 0,
  interior: 0,
  progressMediaDate: '',
  progressMediaUrl: '',
};

const loadProgress = async () => {
  try {
    const progressData = await fetchProgressData();

    updateProgress(progress, progressData);

    return progress;
  } catch (error) {
    console.error('Error loading apartments:', error);
    return progress;
  }
};

// Function to update apartment availability
const updateProgress = (progress: Progress, progressData: ProgressData) => {
  const data = [...(progressData.DetaljiProjektaBrda || [])];
  progress.startDate =
    data.find((e) => e.id.includes(PROGRESS.START_DATE))?.status ?? '10/2024';
  progress.endDate =
    data.find((e) => e.id.includes(PROGRESS.END_DATE))?.status ?? '12/2027';
  progress.ending = parseInt(
    data.find((e) => e.id.includes(PROGRESS.ENDING))?.status ?? '0',
  );
  progress.planing = parseInt(
    data.find((e) => e.id.includes(PROGRESS.PLANING))?.status ?? '0',
  );
  progress.phase = parseInt(
    data.find((e) => e.id.includes(PROGRESS.PHASE))?.status ?? '0',
  );
  progress.interior = parseInt(
    data.find((e) => e.id.includes(PROGRESS.INTERIOR))?.status ?? '0',
  );
  progress.progressMediaDate =
    data.find((e) => e.id.includes(PROGRESS.PROGRESS_MEDIA_DATE))?.status ?? '';
  progress.progressMediaUrl =
    data.find((e) => e.id.includes(PROGRESS.PROGRESS_MEDIA_URL))?.status ?? '';
};

let PROGRESS_DATA: Progress;

// Initialize the apartments
const initializeProgressData = async () => {
  PROGRESS_DATA = await loadProgress();

  console.log('Apartments initialized and availability updated.');
  return PROGRESS_DATA;
};

const useProgress = () => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [progressData, setProgressData] = useState<Progress>();

  return {
    isInitialized,
    setIsInitialized,
    progressData,
    setProgressData,
    openModal,
    setOpenModal,
  };
};

export { initializeProgressData, useProgress };
